import { trackerReducer, SET_DRILL_PATH } from '../reducers';

export const convertToBreakdownPath = (breakdownPath, options) => {
  return breakdownPath.reduce((acc, { openRows, breakdownId }, i) => {
    return [
      ...acc,
      ...openRows.map((rowId) => {
        const parent = rowId;
        const drillPath = rowId.split('///').map((levelId) => {
          const [type, id] = levelId.split(':');

          return {
            type,
            id,
          };
        });
        const nextDrillPath = [...drillPath, { type: breakdownId, id: '' }];
        return {
          ...trackerReducer(options, {
            type: SET_DRILL_PATH,
            payload: nextDrillPath,
          }),
          parent,
          breakdownLevel: i + 1,
        };
      }),
    ];
  }, []);
};

export const convertToBreakdownPath2 = (breakdownPath, options) => {
  return breakdownPath.reduce((acc, { openRows, breakdownId }, i) => {
    return [
      ...acc,
      ...openRows.map((rowId) => {
        const parent = rowId;
        const drillPath = rowId.split('///').map((levelId) => {
          const [type, id] = levelId.split(':');

          return {
            type,
            id,
          };
        });
        const nextDrillPath = [...drillPath, { type: breakdownId, id: '' }];
        return {
          ...trackerReducer(options, {
            type: SET_DRILL_PATH,
            payload: nextDrillPath,
          }),
          parent,
          breakdownLevel: i + 1,
        };
      }),
    ];
  }, []);
};
